import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingBottomImage: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M11.5 9h-7v7h7zM0 4.5h16V7H0zM0 0h16v2.5H0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingBottomImage
